// extracted by mini-css-extract-plugin
module.exports = {"Container":"vehicle-card-image-mobile_Container__XwuIy","Image":"vehicle-card-image-mobile_Image__0w8HW"};